import Helper from '@ember/component/helper';
export default class ArrayIncludes extends Helper {
  compute([array, value]) {
    return array.includes(value);
  }
}